import Component from '@glimmer/component';

import { action } from '@ember/object';
import didInsert from '@ember/render-modifiers/modifiers/did-insert';
import { service } from '@ember/service';
import { cached, tracked } from '@glimmer/tracking';

import trustedHtml from 'rise-ui/helpers/trusted-html.js';

export default class DynamicNode extends Component {
  @service dynamicNode;

  @tracked updateIndex = 0;

  scope = {
    data: { ...(this.args.data || {}) },
  };

  @action didInsert(el) {
    this.compiled?.scope.didInsert(el);
  }

  output() {
    ++this.updateIndex;
  }

  @cached get compiled() {
    this.updateIndex; // consume
    const { node } = this.args;
    return this.dynamicNode.compile(node)(this.scope);
  }

  get html() {
    return this.compiled?.html;
  }

  <template>
    <span {{didInsert this.didInsert}}>{{trustedHtml this.html}}</span>
  </template>
}
